import React from "react";
import RoomContainer from "./RoomContainer";

const ZoneContainer = ({ data }) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gridColumnGap: "90px",
        gridRowGap: "50px",
        padding: "10px 15px",
        justifyContent: "space-between",
        backgroundColor: "#1e2024",
      }}
    >
      {data.sets.map((f, i) => {
        return <RoomContainer key={i} data={f} />;
      })}
    </div>
  );
};

export default ZoneContainer;
